import { connect } from 'react-redux'
import _ from 'lodash'
import { transformSubStationOptions } from '../../lib/optionNormalizer'
import QueryPage from '../../components/Listing/QueryPage/QueryPage'
import { fetchProposalSubStations, fetchProducts, fetchListings } from '../../actions/serviceActions/proposal'
import { setI13nData } from '../../actions/common'
import { bindActionCreators } from 'redux'
import { isPathInPrivilegedPages } from '../../lib/authWrapper'
import confUtil from '../../../lib/confUtil'
import { IconPopoverLabel } from '../../components/Proposal/Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import styles from './QueryPage.css'
import { PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/dist/constants/proposal.js'

export const UPDATE_LISTING_ACTIONS = [
  {
    name: (
      <IconPopoverLabel
        className={styles.labelWithIcon}
        popoverPlacement='left'
        popoverContent='可複製賣場及商品資訊進行「新增一般賣場提案」'
      >
        複製賣場
      </IconPopoverLabel>
    ),
    targetPath: `/proposal/${PROPOSAL_TYPE.CLONE_LISTING}`,
    followingPrivilegedPaths: ['cloneListing']
  },
  {
    name: (
      <IconPopoverLabel
        className={styles.labelWithIcon}
        popoverPlacement='left'
        popoverContent='可同時修改品名、圖片、供應商商品料號、商品型號、特色標題、商品特色、規格表、影片、詳情與保證'
      >
        修改賣場資訊
      </IconPopoverLabel>
    ),
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_LISTING}`,
    followingPrivilegedPaths: ['updateListing']
  },
  {
    name: '修改詳情與保證',
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_COPY}`,
    followingPrivilegedPaths: ['scmUpdateCopyProposal', 'updateCopy']
  },
  {
    name: '修改賣場/商品圖片',
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_IMAGE}`,
    followingPrivilegedPaths: ['scmUpdateImage', 'updateImage']
  },
  {
    name: '修改規格表',
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_ATTRIBUTE}`,
    followingPrivilegedPaths: ['updateAttribute']
  },
  {
    name: '調整賣場屬性項目',
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_LISTING_MODEL}`,
    followingPrivilegedPaths: ['updateListingModel']
  },
  {
    name: '修改賣場影片',
    targetPath: `/proposal/${PROPOSAL_TYPE.UPDATE_VIDEO}`,
    followingPrivilegedPaths: ['updateVideo']
  }
]

/**
 * 取得 user 可以使用的賣場更新 action
 */
export const getPrivilegedActions = privilegedPages => {
  const _isPrivileged = pathKey => isPathInPrivilegedPages(confUtil.getUrl(pathKey), privilegedPages)
  const _hasMatchedPrivileged = ({ followingPrivilegedPaths }) => followingPrivilegedPaths.some(_isPrivileged)

  const privilegedActions = UPDATE_LISTING_ACTIONS.filter(_hasMatchedPrivileged)

  return privilegedActions
}

const mapStateToProps = (state, ownProps) => {
  const sharedLink = _.get(state, 'supplier.sharedLink', {})

  const subStations = _.get(state, 'proposal.subStations', [])
  const subStationOptions = transformSubStationOptions(subStations, state.flags)

  const privilegedPages = _.get(state, 'page.privilegedPages', [])
  const privilegedActions = getPrivilegedActions(privilegedPages)

  return {
    env: state.page.env,
    sharedLink,
    subStationOptions,
    privilegedActions,
    user: state.page.user,
    flags: state.flags
  }
}

const mapDispatchToProps = dispatch => {
  const actions = bindActionCreators(
    {
      setI13nData,
      fetchProducts,
      fetchListings
    }
    , dispatch
  )

  return { actions }
}

QueryPage.fetchData = ({ store, match, req, res }) => {
  try {
    const tasks = [
      store.dispatch(fetchProposalSubStations())
    ]

    return Promise.all(tasks)
  } catch (e) {
    throw e
  }
}

const MappedContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(QueryPage)

export default MappedContainer
